import React from 'react';
import { Link } from 'react-router';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import {RowItemProcess} from './datatable/list';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Danhmuc, DuLieuHeThong } from 'api';
import { header } from 'constants/table';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";
import {CheckPermission} from 'modules/login/CheckPermission';
import Search from './Search.jsx';
import {TextArea, Input} from 'components/tt-forms/common';
import { DropDownQuyTrinh } from 'components/tt-forms';
import {MasterLayout} from 'layout';
import classnames from 'classnames';
import {DropDownTreeMultipleSelect} from 'components/tt-forms/common';

class Process extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      dataOptions: [],
      dataSelected: [],
      dataCapDonViQuyTrinhs: [],
      capDonViQuyTrinhs: '',
      donViCon: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      popupAddCategory: false,
      addType: 0,
      ten: '',
      moTa: '',
      giaTri: '',
      categoryId: 0,
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      isValid: true
    };
  }

  componentDidMount() {
    this.getListData();
    this.getListDV();
    this.getCapDonViQuyTrinh();
  }

  onChange(name, e) {
    if (name === 'DonVi') {
      this.setState({
        dataSelected: e
      });
    } else if (name === 'donViCon') {
      this.setState({donViCon: !this.state.donViCon});
    } else {
      this.setState({[name]: e.target.value});
    }
  }

  getListData() {
    this.setState({
      tableLoading: true
    });

    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    };
    Danhmuc.actions.getListQuyTrinh.request(null, params).then(res => {
      if (res && res.data && res.data._embedded.medial_DonViQuyTrinhInfoes) {
        this.setState({
          data: res.data._embedded.medial_DonViQuyTrinhInfoes,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleChangePageSize(size) {
    this.setState({pageData: {
      ...this.state.pageData,
      size: size,
      number: 0
    }}, () => {
      this.getListData();
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  createCategory() {
    if (this.validateSubmitForm()) {
      let params = {
        capDonVi: this.state.capDonViQuyTrinhs || ''
      };

      if (this.state.dataSelected && this.state.dataSelected.length > 0) {
        let ids = [];
        this.state.dataSelected.forEach(item => {
          ids.push(item.value);
        });
        params.donViIds = ids;
      }
      this.setState({buttonLoading: true});
      this.props.danhMuc.postQuyTrinh('',params).then(res => {
        this.getListData();
        this.closeDialog();
        Toastr(msg.addCategorySucess,'success');
        this.setState({
          dataSelected: [],
          capDonViQuyTrinhs: '',
          buttonLoading: false
        });
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail,'error');
          this.setState({buttonLoading: false});
        }
      });
    }
  }

  handlePageClick(page) {
    this.setState({pageData: {
      ...this.state.pageData,
      number: page.selected
    }}, () => {
      this.getListData();
    })
  }

  handleDelete(categoryId) {
     if(categoryId){
      this.setState({buttonLoading: true});
      this.props.danhMuc.deleteQuyTrinh({idDonVi: categoryId}).then(res => {
        this.getListData();
        Toastr(msg.delCategorySucess,'success');
        this.setState({buttonLoading: false});
      }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail,'error');
            this.setState({buttonLoading: false});
          }
      });
     }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  openDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
  }

  closeDialog() {
    this.setState({popupAddCategory: !this.state.popupAddCategory});
  }

  openAddNewCategory() {
    this.openDialog();
    this.setState({
      dataSelected: [],
      capDonViQuyTrinhs: '',
      isValid: true
    });
  }

  getListDV() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    DuLieuHeThong.actions.getCoQuanQuanLy.request().then(res => {
      if (res && res.data && res.data._embedded) {
        let dataDonVi = [...res.data._embedded.coQuanQuanLies]
        let DonVi = dataDonVi.filter(state => {
          return state.coQuanQuanLyId === userInfo.donViId
        })
        this.setState({
          dataSelected: [
            {value: DonVi.length > 0 ? DonVi[0].coQuanQuanLyId : '', label: DonVi.length > 0 ? DonVi[0].ten : ''}
          ],
          dataOptions: res.data._embedded.coQuanQuanLies
        });
      }
    });
  }

  getCapDonViQuyTrinh() {
    DuLieuHeThong.actions.getCapDonViQuyTrinhs.request().then(res => {
      if (res && res.data) {
        this.setState({dataCapDonViQuyTrinhs: res.data});
      }
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-reception"></i>Quản lý quy trình</p>
            </div>
            <div className="right-content">
              {
                CheckPermission('PROCESS_THEM') &&
                  <Link className="btn-green" onClick={this.openAddNewCategory.bind(this)}><i className="tt tt-addfile"></i>Thêm mới</Link>
              }
            </div>
          </div>
          <div className="bottom-content">
            <DataTable
              header={header.categoryGroup.quytrinh}
              dataList={this.state.data}
              pageData={this.state.pageData}
              parent={this}
              hideButtonExport
              tableLoading={this.state.tableLoading}
            >
              <RowItemProcess buttonLoading={this.state.buttonLoading}/>
            </DataTable>
          </div>
          <Dialog
            isOpen={this.state.popupAddCategory}
            onClose={this.closeDialog.bind(this)}
            title="Thêm mới quy trình"
            iconName="add-new"
            className="panel-popup category">
            <div className="pt-dialog-body">
              <div className='col-min-83 no-gutter clear-left'>
                <DropDownTreeMultipleSelect className='tree-selected col-min-83' label="Đơn vị" dataOptions={this.state.dataOptions} dataSelected={this.state.dataSelected} onChange={this.onChange.bind(this, 'DonVi')} selectAllChildren={this.state.donViCon} propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' bindValidator={this} channel="formTaoDon" require/>
                <DropDownQuyTrinh className='tree-selected col-min-83' label='Cấp đơn vị' data={this.state.dataCapDonViQuyTrinhs} selectedValue={this.state.capDonViQuyTrinhs} onChange={this.onChange.bind(this, 'capDonViQuyTrinhs')} name='capDonViQuyTrinhs' bindValidator={this} channel="formTaoDon" require/>
              </div>
            </div>
            <div className="pt-dialog-footer">
                <Link onClick={this.closeDialog.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className={classnames('btn-action btn-save', {'btn-loading': this.state.buttonLoading})} onClick={this.createCategory.bind(this)} >
                  <span>Thêm mới</span>
                </Link>
            </div>
          </Dialog>
        </div>
      </MasterLayout>
    );
  }
}

Process.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

function bindStateToProps(state) {
  return {};
}

function bindDispatchToProps(dispatch) {
  return {
    danhMuc: bindActionCreators(Danhmuc.actions, dispatch)
  };
}
export default connect(bindStateToProps, bindDispatchToProps)(Process);



// WEBPACK FOOTER //
// ./src/components/modules/category/Process.jsx